<template>
  <div class="user-details-widget">
    <div class="profile-widget">
      <img v-if="user_type == 'HOST' && user.profile_image" class="profile-image" width="100" :src="$store.state.ASSETS_BASE_URL +
        '/assets/uploaded/' +
        user.profile_image
        " />
      <img v-else class="profile-image" src="@/assets/images/icons/empty_profile.svg" />
      <h3 v-if="user_type == 'HOST' && user" class="user-name">
        {{ `${user.first_name} ${user.last_name}` }}
      </h3>
      <h3 v-if="user_type == 'GUEST' && type == 'chat'" class="user-name">
        {{ `${value.names}` }}
      </h3>
      <h3 v-if="user_type == 'GUEST' && type == 'transation'" class="user-name">
        Unknown user
      </h3>

      <b-taglist v-if="user_type == 'HOST' && user && type == 'member'" attached>
        <b-tag type="is-dark">STATUS</b-tag>
        <b-tag v-if="user.activated" type="is-success">VERIFIED</b-tag>
        <b-tag v-else type="is-warning">UNVERIFIED</b-tag>
      </b-taglist>

      <b-taglist v-if="type == 'chat'" attached>
        <b-tag type="is-dark">{{ user_type }}</b-tag>
        <b-tag v-if="value.status == 'OPENED'" type="is-success">OPENED</b-tag>
        <b-tag v-if="value.status == 'CLOSED'" type="is-danger">CLOSED</b-tag>
      </b-taglist>

      <b-taglist v-if="type == 'transation'" attached>
        <b-tag type="is-dark">{{ value.payment_type }}</b-tag>
        <b-tag v-if="value.status == 'payed'" type="is-success">PAYED</b-tag>
        <b-tag v-if="value.status == 'pending'" type="is-warning">PENDING</b-tag>
      </b-taglist>
    </div>

    <div class="right-panel-heading"><span>Contact Info </span></div>

    <div v-if="user_type == 'GUEST'" class="guest-profile-contact">
      <b-field>
        <b-input v-model="guest_username" placeholder="Email or Phone" expanded></b-input>
        <p @click="getUserInformation(value, true)" class="control">
          <span class="button is-static">Search</span>
        </p>
      </b-field>
    </div>

    <div v-if="user_type == 'HOST' && user.phone" class="profile-phone">
      <label class="label">Phone</label>
      <span class="value">{{ user.phone }}</span>
    </div>
    <div v-if="user_type == 'HOST' && user.email" class="profile-email">
      <label class="label">Email</label>
      <span class="value"> {{ user.email }} </span>
    </div>

    <div v-if="type == 'transation'" class="right-panel-heading">
      <span>Billing Info </span>
    </div>

    <div v-if="type == 'transation'" class="billing-content-widget">
      <div class="billing-item" v-if="value.bill_to_first_name || value.bill_to_last_name">
        <label class="label">Names</label>
        <span class="value">
          {{ value.bill_to_first_name + " " + value.bill_to_last_name }}</span>
      </div>
      <div class="billing-item" v-if="value.bill_to_phone">
        <label class="label">Phone</label>
        <span class="value"> {{ value.bill_to_phone }}</span>
      </div>
      <div class="billing-item" v-if="value.bill_to_email">
        <label class="label">Email</label>
        <span class="value"> {{ value.bill_to_email }}</span>
      </div>

      <div class="billing-item" v-if="value.bill_to_country">
        <label class="label">Country</label>
        <span class="value" v-if="billing_country_name">
          {{ billing_country_name.label }} ({{ value.bill_to_country }})</span>
        <span class="value" v-else> {{ value.bill_to_country }}</span>
      </div>

      <div class="billing-item" v-if="value.bill_to_city">
        <label class="label">City</label>
        <span class="value"> {{ value.bill_to_city }}</span>
      </div>

      <div class="billing-item" v-if="value.bill_to_line1">
        <label class="label">Address</label>
        <span class="value"> {{ value.bill_to_line1 }}</span>
      </div>
    </div>

    <!-- Loading-->
    <div v-if="loading_user_info" class="subscription-widget">
      <div v-for="(item, index) in 4" :key="index" class="subscription-item">
        <div class="subscription-item-left">
          <b-skeleton width="20%" :animated="true"></b-skeleton>
          <span class="subscription-item-price"><b-skeleton width="80%" :animated="true"></b-skeleton>
          </span>
        </div>
        <div class="subscription-item-right">
          <b-skeleton width="10px" :animated="true"></b-skeleton>
        </div>
      </div>
    </div>
    <!-- End Loading-->
    <div class="right-panel-heading">
      <span>Channels Subscriptions</span>
    </div>
    <div class="subscription-widget" v-if="!loading_user_info && user_info">
      <div class="subscription-item" v-for="(item, index) in user_info.subscriptions" :key="index">
        <div class="subscription-item-left">
          <h1 v-if="item.channel">{{ item.channel.title }}</h1>
          <h3>
            <b-taglist attached>
              <b-tag type="is-success" v-if="item.status == 'active'">Payed</b-tag>
              <b-tag type="is-danger" v-else>Pending</b-tag>
              <b-tag type="is-default" v-if="item.transaction">
                <span style="text-transform: uppercase;">
                  {{ item.transaction.payment_type }}
                </span>
              </b-tag>
            </b-taglist>
            <span class="text">{{ `${item.transaction ? item.transaction.currency + item.transaction.amount : ''}` }}
              {{
                " / " + moment(item.expire_date).diff(moment(item.created_at), 'days') + ' days of sub'

              }}
            </span>
          </h3>
          <span class="subscription-item-price">{{ moment(item.created_at).format("MMM Do YYYY, h:mm A") }} -
            {{ moment(item.expire_date).format("MMM Do YYYY, h:mm A") }}
          </span>
        </div>
        <div class="subscription-item-right">
          <b-dropdown animation="none" aria-role="menu" class="is-pulled-right" position="is-bottom-left">
            <template #trigger>
              <b-icon icon="dots-vertical"></b-icon>
            </template>

            <b-dropdown-item aria-role="listitem" @click="changeSubStatus(item, 'pending')">Deactivate</b-dropdown-item>
            <b-dropdown-item aria-role="listitem" @click="changeSubStatus(item, 'active')">Activate</b-dropdown-item>
            <b-dropdown-item @click="deleteSubscriptionItem(item)" aria-role="listitem">Delete</b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </div>
    <div class="right-panel-heading"><span>Events Tickets</span></div>
    <div class="tickets-widget" v-if="!loading_user_info && user_info">
      <div class="ticket-item" v-for="(item, index) in user_info.tickets" :key="index">
        <div class="ticket-item-left">
          <h1 v-if="item.streaming">{{ item.streaming.title }}</h1>
          <h3>
            <b-taglist attached>
              <b-tag type="is-success" v-if="item.activated">Activated</b-tag>
              <b-tag type="is-danger" v-else>Inactive</b-tag>
              <b-tag type="is-default" v-if="item.streaming">
                <span> {{ item.streaming.payment_type }}</span>
              </b-tag>
            </b-taglist>
            <span class="text" v-if="item.streaming"> {{ item.streaming.currency }}{{ item.streaming.amount }}</span>
          </h3>
          <span class="ticket-item-token">
            {{ item.ticket_token }} - {{ moment(item.created_at).format("MMM Do YYYY, h:mm A") }}
          </span>
        </div>
        <div class="ticket-item-right">
          <b-dropdown animation="none" aria-role="menu" class="is-pulled-right" position="is-bottom-left">
            <template #trigger>
              <b-icon icon="dots-vertical"></b-icon>
            </template>

            <b-dropdown-item aria-role="listitem" @click="changeTikcetStatus(item, false)">Deactivate</b-dropdown-item>
            <b-dropdown-item aria-role="listitem" @click="changeTicketStatus(item, true)">Activate</b-dropdown-item>
            <b-dropdown-item @click="deleteTicketItem(item)" aria-role="listitem">Delete</b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </div>
    <widgetNotfound v-if="user_info && user_info.tickets.length == 0" title="Ticket information"
      subtitle="Ticket not found"></widgetNotfound>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    value: {
      type: Object,
      default: null,
    },
    user: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      default: "",
    },
    user_type: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    user_info: null,
    loading_user_info: false,
    guest_username: "",
  }),
  watch: {
    value(val) {
      let vm = this;
      vm.getUserInformation(val);
    },
  },
  computed: {},
  mounted() {
    let vm = this;
    vm.getUserInformation(vm.value);
  },
  methods: {
    getUserInformation(item, isSearching = false) {
      let vm = this;
      if (vm.type == "chat" && !isSearching) {
        vm.guest_username = vm.value.email_phone;
      }
      let email_phone = "";
      if (vm.user_type != "HOST" && vm.type == "chat") {
        email_phone = item.email_phone;
      }
      if (vm.user_type != "HOST" && vm.type == "transation") {
        email_phone = item.bill_to_phone || item.bill_to_email;
      }

      vm.loading_user_info = true;
      vm.$store
        .dispatch("USER_GET_INFORMATION", {
          user_id: vm.user_type == "HOST" ? vm.user.id : null,
          user_type: vm.user_type,
          email_phone: email_phone,
          guest_username: vm.guest_username,
        })
        .then((response) => {
          vm.loading_user_info = false;
          vm.user_info = response.data.return;
        })
        .catch(({ response }) => {
          vm.loading_user_info = false;
          vm.$notify({
            group: "status",
            type: "warn",
            title: "OOPS!!!",
            text: response.data.message,
          });
        });
    },
    changeSubStatus(item, status) {
      let vm = this;
      vm.$store
        .dispatch("SUPPORT_CHAT_CHANGE_SUBSCRIPTION_STATUS", {
          id: item.id,
          status: status,
          user_id: vm.user_info.user_id,
        })
        .then((response) => {
          vm.getUserInformation(vm.value);
          vm.$notify({
            group: "status",
            type: "success",
            title: "Important message",
            text: response.data.message,
          });
        })
        .catch(({ response }) => {
          vm.$notify({
            group: "status",
            type: "warn",
            title: "OOPS!!!",
            text: response.data.message,
          });
        });
    },
    deleteSubscriptionItem(item) {
      let vm = this;
      vm.$confirm({
        title: "Confirm",
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: (confirm) => {
          if (confirm) {
            vm.$store
              .dispatch("SUPPORT_CHAT_DELETE_SUBSCRIPTION", {
                id: item.id,
              })
              .then((response) => {
                vm.getUserInformation(vm.value);
                vm.$notify({
                  group: "status",
                  type: "success",
                  title: "Important message",
                  text: response.data.message,
                });
              })
              .catch(({ response }) => {
                vm.$notify({
                  group: "status",
                  type: "warn",
                  title: "OOPS!!!",
                  text: response.data.message,
                });
              });
          }
        },
      });
    },
    // Ticket
    changeTicketStatus(item, status) {
      let vm = this;
      vm.$store
        .dispatch("SUPPORT_CHAT_CHANGE_TICKET_STATUS", {
          id: item.id,
          status: status,
          user_id: vm.user_info.user_id,
        })
        .then((response) => {
          vm.getUserInformation(vm.value);
          vm.$notify({
            group: "status",
            type: "success",
            title: "Important message",
            text: response.data.message,
          });
        })
        .catch(({ response }) => {
          vm.$notify({
            group: "status",
            type: "warn",
            title: "OOPS!!!",
            text: response.data.message,
          });
        });
    },
    deleteTicketItem(item) {
      let vm = this;
      vm.$confirm({
        title: "Confirm",
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: (confirm) => {
          if (confirm) {
            vm.$store
              .dispatch("SUPPORT_CHAT_DELETE_TICKET", {
                id: item.id,
              })
              .then((response) => {
                vm.getUserInformation(vm.value);
                vm.$notify({
                  group: "status",
                  type: "success",
                  title: "Important message",
                  text: response.data.message,
                });
              })
              .catch(({ response }) => {
                vm.$notify({
                  group: "status",
                  type: "warn",
                  title: "OOPS!!!",
                  text: response.data.message,
                });
              });
          }
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.user-details-widget {
  .profile-widget {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .profile-image {
      width: 150px;
      height: 150px;
      object-fit: cover;
      border-radius: 50%;
      border: #fff solid 6px;
      z-index: 99;
      background: #fff;
    }

    .user-name {
      font-size: 22px;
    }
  }

  .right-panel-heading {
    color: rgb(0 0 0);
    padding: 9px 15px;
    margin-bottom: 6px;
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #ddd;

    span {
      font-size: 18px;
    }
  }

  .guest-profile-contact {
    padding: 0px 10px;
    padding-top: 10px;
  }

  .profile-phone,
  .profile-email {
    padding-left: 30px;

    .label {
      font-size: 16px;
      color: #000000;
      margin-bottom: 0px;
    }

    .value {
      font-size: 14px;
      color: #616161;
    }
  }

  .billing-content-widget {
    .billing-item {
      padding-left: 30px;
      margin-bottom: 20px;

      .label {
        font-size: 16px;
        color: #000000;
        margin-bottom: 0px;
      }

      .value {
        font-size: 14px;
        color: #616161;
      }
    }
  }

  .subscription-widget {
    .subscription-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      border-bottom: 1px solid #e9e9e9;
      padding: 5px 25px;

      .subscription-item-left {
        display: flex;
        flex-direction: column;
        width: calc(100% - 30px);

        h3 {
          display: flex;

          * {
            margin-bottom: 0px !important;
          }

          .text {
            margin-left: 10px;
          }
        }

        .subscription-item-price {
          font-size: 12px;
          color: rgb(73, 73, 73);
          margin-top: 10px;
        }
      }

      .subscription-item-right {
        width: 30px;
      }
    }
  }

  .tickets-widget {
    display: flex;
    flex-direction: column;

    .ticket-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      border-bottom: 1px solid #e9e9e9;
      padding: 5px 25px;

      .ticket-item-left {
        display: flex;
        flex-direction: column;
        width: calc(100% - 30px);

        h3 {
          display: flex;

          * {
            margin-bottom: 0px !important;
          }

          .text {
            margin-left: 10px;
          }
        }

        .ticket-item-token {
          font-size: 12px;
          color: rgb(73, 73, 73);
          margin-top: 10px;
        }
      }

      .ticket-item-right {
        width: 30px;
      }
    }
  }
}
</style>